import { render, staticRenderFns } from "./VoteRecord.vue?vue&type=template&id=0e80956c&"
import script from "./VoteRecord.vue?vue&type=script&lang=js&"
export * from "./VoteRecord.vue?vue&type=script&lang=js&"
import style0 from "./VoteRecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports